export const MORE_ITEM = `Еще`;
export const ADDRESS_BUTTON_TEXT = `Адрес офиса`;
